import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";

export default function Comparison_RenewalPremium(props) {
    const device = React.useContext(DeviceContext);
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent2 = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const headers = [[
        props.city ? props.city.toUpperCase() :
            props.states.length > 1 ? "ALL STATES" :
                props.states[0] === 'MI' ? 'MICHIGAN' :
                    props.states[0] === 'NJ' ? 'NEW JERSEY' :
                        props.states[0] === 'PA' ? 'PENNSYLVANIA' : '',
        'Range A',
        'Range B',
        'Change'
    ]];

    const [data, setData] = React.useState([
        ['Up for Renewal', '', '', ''],
        [<>Renewed<TooltipButton tooltipText="includes reinstatements" /></>, '', '', ''],
        ['Reinstated', '', '', ''],
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", `/Comparison/GetRenewalPremium`, {
            startDateA: props.startDateA,
            endDateA: props.endDateA,
            startDateB: props.startDateB,
            endDateB: props.endDateB,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = response.map((row) => {
                return [
                    row.row == 'Renewed' ? <>Renewed<TooltipButton tooltipText="includes reinstatements" /></> : row.row,
                    currency.format(row.rangeA),
                    currency.format(row.rangeB),
                    {
                        style: { color: row.change > 0 ? "green" : "red" },
                        text: <>
                            {row.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                            {row.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                            {percent2.format(row.change / 100)}
                        </>
                    }
                ];
            });

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                loading={loading}
                fixedColumns={1}
                style={{
                    Grid: {
                        Item: {
                            padding: device.isMobile ? "1.3em" : "2.5em",
                            margin: device.isMobile ? "0" : "2.5em"
                        }
                    },
                    Table: {
                        Container: { marginTop: "0", maxHeight: "unset" },
                        TableSX: { minWidth: '605px', tableLayout: 'fixed' }, // fixed = all columns same width
                        Header: { textAlign: "left" },
                        Body: { textAlign: "left" }
                    }
                }}
                headers={headers}
                rows={data}
            />
        </div>
    );
};
